import { createContext, useContext, useReducer, useCallback, useState } from "react";

const CartContext = createContext(null);

const cartReducer = (state, action) => {
  switch (action.type) {
    case "ADD_ITEM": {
      const existing = state.findIndex(
        (i) => i.menuItemId === action.payload.menuItemId && i.size === action.payload.size
      );
      if (existing >= 0) {
        const updated = [...state];
        updated[existing] = {
          ...updated[existing],
          quantity: updated[existing].quantity + action.payload.quantity,
        };
        return updated;
      }
      return [...state, { ...action.payload, cartId: crypto.randomUUID() }];
    }
    case "REMOVE_ITEM":
      return state.filter((i) => i.cartId !== action.payload);
    case "UPDATE_QTY":
      return state.map((i) =>
        i.cartId === action.payload.cartId
          ? { ...i, quantity: Math.max(1, action.payload.quantity) }
          : i
      );
    case "CLEAR":
      return [];
    default:
      return state;
  }
};

export function CartProvider({ children }) {
  const [cart, dispatch] = useReducer(cartReducer, []);
  const [cartOpen, setCartOpen] = useState(false);

  const addItem = useCallback((item) => {
    dispatch({ type: "ADD_ITEM", payload: item });
  }, []);

  const removeItem = useCallback((cartId) => {
    dispatch({ type: "REMOVE_ITEM", payload: cartId });
  }, []);

  const updateQuantity = useCallback((cartId, quantity) => {
    dispatch({ type: "UPDATE_QTY", payload: { cartId, quantity } });
  }, []);

  const clearCart = useCallback(() => {
    dispatch({ type: "CLEAR" });
  }, []);

  const totalItems = cart.reduce((sum, i) => sum + i.quantity, 0);
  const subtotal = cart.reduce((sum, i) => sum + i.price * i.quantity, 0);

  return (
    <CartContext.Provider
      value={{ cart, addItem, removeItem, updateQuantity, clearCart, totalItems, subtotal, cartOpen, setCartOpen }}
    >
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used within CartProvider");
  return ctx;
}
